import React, { useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { TableCell, TableRow, TableBody } from "@material-ui/core";

export default function TableSkeleton({ noOfColumns, noOfLines,flag }) {
  const [columns, setColumns] = useState(Array.from(Array(noOfColumns).keys()));
  const [lines, setLines] = useState(Array.from(Array(noOfLines).keys()));

  return (
    <TableBody>
      {lines.map((item) => (
        <TableRow>
          {columns.map((item) => (
            <TableCell size="small">
              <Skeleton variant="text"  width={flag && 120} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
